import React, { createContext, useContext } from "react";

import { UserObject } from "@/types/user";

export interface UserContextType {
  user: UserObject;
}

const UserContext = createContext<UserContextType | undefined>(undefined);

interface UserProviderProps {
  children: React.ReactNode;
  user: UserObject;
}

export const UserProvider: React.FC<UserProviderProps> = ({
  children,
  user,
}) => {
  return (
    <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
